module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/angular/aws-lex-web-ui-master/aws-lex-web-ui-master/node_modules/babel-runtime/core-js/symbol.js
// module id = ../../../node_modules/babel-runtime/core-js/symbol.js
// module chunks = 0